<template>
    <div id="ProgressHeader">
        <div class="container py-2">
            <progress-header-step
                class="d-inline-block"
                :label="$t('taxi.components.progress.search')"
                :is-completed="searchParameters != null && searchParameters.start_place != null && searchParameters.start_place != null && searchParameters.departure_date != null && searchParameters.departure_time != null"
                :is-clickable="true"
                :is-active="currentRoute === 'smart-taxi.index'"
                route="smart-taxi.index"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" size="sm" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('taxi.components.progress.journey_select')"
                :is-completed="travel !== null"
                :is-clickable="travel !== null"
                :is-active="currentRoute === 'smart-taxi.vehicles'"
                route="smart-taxi.vehicles"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" size="sm" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('taxi.components.progress.passengers_data')"
                :is-completed="passengers !== null && currentRoute !== 'smart-taxi.passengers'"
                :is-clickable="passengers !== null"
                :is-active="currentRoute === 'smart-taxi.passengers'"
                route="smart-taxi.passengers"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" size="sm" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('taxi.components.progress.addresses')"
                :is-completed="hasAddresses && currentRoute !== 'smart-taxi.addresses'"
                :is-clickable="hasAddresses"
                :is-active="currentRoute === 'smart-taxi.addresses'"
                route="smart-taxi.addresses"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" size="sm" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('taxi.components.progress.additional_options')"
                :is-completed="travelOptionPrices !== null && currentRoute !== 'smart-taxi.options'"
                :is-clickable="travelOptionPrices !== null"
                :is-active="currentRoute === 'smart-taxi.options'"
                route="smart-taxi.options"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" size="sm" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('taxi.components.progress.summary_and_payment')"
                :is-completed="false"
                :is-clickable="travel !== null && passengers !== null && hasAddresses && travelOptionPrices !== null"
                :is-active="currentRoute === 'smart-taxi.summary'"
                route="smart-taxi.summary"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ProgressHeaderStep from '@components/ProgressHeaderStep';

    export default {
        components: {
            ProgressHeaderStep,
        },

        data() {
            return {
                currentRoute: this.$router.currentRoute.name,
            };
        },

        computed: {
            ...mapGetters({
                travel: 'familyAirportTaxi/getTravel',
                passengers: 'familyAirportTaxi/getPassengers',
                hasAddresses: 'familyAirportTaxi/hasAddresses',
                travelOptionPrices: 'familyAirportTaxi/getTravelOptionPrices',
                searchParameters: 'familyAirportTaxi/searchParameters',
            }),
        },
    };
</script>
